// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__31mVW","inner":"style_inner__1RjYm","bottom":"style_bottom__2_UCF","copyright":"style_copyright__2oXoa"};